import { RecursiveTranslations } from "@/data/types"
import { EmptyBoxIcon } from "../icons"

interface Props {
  translations?: RecursiveTranslations
}

export default function NoData({ translations }: Props) {
  return (
    <div className="flex flex-col items-center justify-center text-center py-16 bg-gray-50 rounded-2xl border border-gray-100">
      <div className="rounded-xl bg-gray-50 border border-gray-200 flex items-center justify-center shadow-sm mb-5 p-3">
        <EmptyBoxIcon />
      </div>
      <p className="text-lg font-normal text-gray-600">
        {translations?.noDataTitle as string || "No data available at this time."}
      </p>
      <p className="text-sm font-light text-gray-500 mt-1">
        {translations?.noDataSubtitle as string || "Check back later for updates."}
      </p>
    </div>
  )
}